import React, {useState, useEffect} from 'react'
import TopNav from "../../component/TopNav/TopNav";
import './WalletLanding.scss'
import "react-circular-progressbar/dist/styles.css";
import BottomNav from "../../component/BottomNav/BottomNav";
import ReuseableListHeader from "../../component/ReuseableListHeader";
import InviteCard from "../../component/InviteCard/InviteCard";
import {MDBModal, MDBModalBody} from "mdbreact";
import AddMoney from "./AddMoney";
import WithdrawMoney from "./WithdrawMoney";
import CashDetail from "./CashDetail";
import {AddWalletData, setActivePage} from "../../Actions";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import WalletCard from "../../component/WalletCard/WalletCard";
import {Zoom, Fade} from "react-reveal";
// import ProfilePic from "../../assets/images/profile-icon.svg";
import NetWorthModal from "./NetWorthModal";
import {fetchQuery} from "relay-runtime";
import environment from "../../Environment";
import WalletDataQuery from "../../queries/WalletData";
import Loading from "../../component/Loading";
import ScrollToTop from "react-router-scroll-top";
import {NonEmptyArray} from "../../util";
import {assetUrl} from "../../serviceApi";
import add from '../../assets/images/ad-money-icon1.png'
import Skeleton from "react-loading-skeleton";

// const add = assetUrl+'images/ad-money-icon1.png'
const downArrow = assetUrl + 'images/withdraw-icon1.png'
const transaction = assetUrl + 'images/icon_transaction.svg'
const how_to_play = assetUrl + 'images/icon_question_in_circle1.svg'
const poll_result = assetUrl + 'images/icon_poll_result.1svg.svg'
const setting = assetUrl + 'images/icon_setting.1svg.svg'
const contact = assetUrl + 'images/icon_headphone1.svg'
const signout = assetUrl + 'images/icon_signout1.svg'
const lock = assetUrl + 'images/signout-image.svg'
const arrow = assetUrl + 'images/arrow-right-white-sm.svg'
const arrowPurple = assetUrl + 'images/arrow-right-sm-purple.svg'
const wrong_image = assetUrl + "images/wrong_image.svg";

const WalletLanding = (props) => {

	const styleWallet = "wallet-"
	const priceAmt = "₹ 65120.10"
	const [activeModal, setActiveModal] = useState("");
	// const priceAmtArray = priceAmt.split('.')
	const [loadingArray, setLoadingArray] = useState([]);
	const [walletData, setWalletData] = useState({});
	const [signOutConfirmation, setSignOutConfirmation] = useState(false);

	useEffect(() => {
		getWalletData()
		props.setActivePage("menu")
		updateLoading(true)
		if (Object.keys(props.order_data).length > 0) {
			props.history.push('/payment');
			updateLoading(false)
		}
	}, [])

	const logout = () => {

		localStorage.clear();
		props.history.push("/");
		window.location.reload();

	}
	// useEffect(() => {

	// 	if(loadingArray.length===1)updateLoading()
	//
	// }, [loadingArray]);

	const getWalletData = () => {
		let variables = {
			userId: props.user_details.user.id
		}
		updateLoading(true)
		fetchQuery(environment, WalletDataQuery, variables)
			.toPromise()
			.then(response => {
				if (NonEmptyArray(response.allWallet)) {

					props.setWalletDataToStore(response.allWallet.edges[0].node);
					setWalletData(response.allWallet.edges[0].node)
					updateLoading(false)
				} else {
					updateLoading(false)
				}
			}, err => {
				updateLoading(false)
				console.log(err);
				setWalletData({})

			});
	}
	// console.log(props.wallet_data)
	const updateLoading = (action) => {

		let tmp_loading_array = loadingArray;
		if (action) {
			tmp_loading_array.push("loading");
			setLoadingArray(tmp_loading_array)
		} else {
			tmp_loading_array.pop();
			setLoadingArray(tmp_loading_array)
		}

	}

	return (

		<Loading loading={loadingArray.length === 0}>
			<ScrollToTop>
				<div  className={"wallet-landing-component"}>
					{/* top nav */}
					<TopNav/>
					<div className={"container"} style={{padding: "0 24px"}}>
						<div className={"my-4"}>
							{loadingArray.length === 0 ?
								<Skeleton width={"100%"} height={"120px"}/> :

								<WalletCard page={"wallet"} walletData={walletData}
								            setActiveModal={() => setActiveModal("cash")}/>
							}
						</div>
						{
							loadingArray.length === 0 ?
								<Skeleton width={"100%"} height={"50px"}/> :
								// <Zoom cascade delay={600}>
									<div className={"d-flex justify-content-between"}>
										<button
											className={styleWallet + "purpleBgBtn d-flex align-items-center justify-content-center px-2 py-1 mr-2"}
											onClick={() => setActiveModal("add")}>
											<p className={'btn-text'}>Add Money</p>
											<img src={add} alt={"alt"}
											     className={"img-fluid wallet-landing-button-icon"}/>
										</button>
										<button
											className={styleWallet + "whiteBgBtn d-flex align-items-center justify-content-center px-2 py-1 ml-2"}
											onClick={() => setActiveModal("withdraw")}>
											<p className={'btn-text'}>Withdraw</p>
											<img src={downArrow} alt={"alt"}
											     className={"img-fluid wallet-landing-button-icon"}/>
										</button>
									</div>
								// </Zoom>
						}

						{/*  profile completion  */}
						<hr className={"my-4 user-docs-seperator"}/>
						{
							loadingArray.length === 0 ?
								<Skeleton width={"100%"} height={"50px"}/> :
						// <Fade bottom>
							<div
								className={styleWallet + "user-document d-flex justify-content-between align-items-center p-3"}>
								<div className={'d-flex'}>

									{/*<Zoom delay={300}>*/}
										{/*<img src={ProfilePic} alt={'alt'}*/}
										{/*                   className={styleWallet + "user-document-image mx-1"}/>*/}
										<div className={styleWallet + "user-document-image"}>
											{
												Object.keys(props.wallet_data).length > 0 && props.wallet_data.user.avatar === null ?
													<p className={styleWallet + "user-document-image-avatar mb-0"}>{props.wallet_data.shortUsername && (props.wallet_data.shortUsername).toUpperCase()}</p>
													:
													<img
														src={props.wallet_data.user && `${props.wallet_data.user.avatar}`}
														alt={"alt"}
														className={styleWallet + "user-document-image"}/>
											}

										</div>
									{/*</Zoom>*/}
									<div style={{marginLeft: "12px"}}
									     className={'d-flex flex-column justify-content-center'}>
										<p className={styleWallet + "user-document-name "}>{props.wallet_data.user ? props.wallet_data.user.username : ""}</p>
										{/*<p className={styleWallet + "user-document-state mb-0"}>Uttar Pradesh</p>*/}
									</div>
								</div>
								<p className={styleWallet + "edit-text mx-2 my-0"}
								   onClick={() => props.history.push("/wallet-profile-edit")}>EDIT</p>
							</div>
						// </Fade>
							}
						{/*  wallet options  */}
						{loadingArray.length === 0 ?
							<Skeleton width={"100%"} height={"60px"} style={{marginTop:"12px",marginBottom:"12px"}} count={6}/> :
							<div className={styleWallet + 'options '}>
								{/*<Fade bottom delay={300}>*/}
									<div className={styleWallet + "optionsWrap py-4 px-0"}
									     onClick={() => props.history.push("/wallet-history")}>
										<ReuseableListHeader heading={"Transaction History"} image={transaction}
										                     viewmore={false}/>
									</div>
								{/*</Fade>*/}
								{/*<Fade bottom delay={300}>*/}
								{/*	<div className={styleWallet + "optionsWrap py-4 px-0"}>*/}
								{/*		<ReuseableListHeader heading={"My Collectibles"} image={collectible} viewmore={false}/>*/}
								{/*	</div>*/}
								{/*</Fade>*/}
								{/*<Fade bottom delay={300}>*/}
									<div className={styleWallet + "optionsWrap py-4 px-0"}
									     onClick={() => props.history.push("/how-to-play")}>
										<ReuseableListHeader heading={"Game Rules"} image={how_to_play}
										                     viewmore={false}/>
									</div>
								{/*</Fade>*/}
								{/*<Fade bottom delay={300}>*/}
									<div className={styleWallet + "optionsWrap py-4 px-0"}
									     onClick={() => props.history.push("/poll-result")}
									>
										<ReuseableListHeader heading={"Poll Results"} image={poll_result}
										                     viewmore={false}/>
									</div>
								{/*</Fade>*/}
								{/*<Fade bottom delay={300}>*/}
									<div className={styleWallet + "optionsWrap py-4 px-0"}
									     onClick={() => props.history.push("/setting")}>
										<ReuseableListHeader heading={"Settings"} image={setting} viewmore={false}/>
									</div>
								{/*</Fade>*/}
								{/*<Fade bottom delay={300}>*/}
									<div className={styleWallet + "optionsWrap py-4 px-0"}
									     onClick={() => props.history.push("/contact-us")}>
										<ReuseableListHeader heading={"Get Help"} image={contact} viewmore={false}/>
									</div>
								{/*</Fade>*/}
								{/*<Fade bottom delay={300}>*/}
									<div className={styleWallet + "optionsWrap py-4 px-0"}
									     onClick={() => {

										     setSignOutConfirmation(true)
									     }}>
										<ReuseableListHeader heading={"Sign Out"} image={signout} viewmore={false}/>
									</div>
								{/*</Fade>*/}
							</div>}

						{/*  invite */}
						<div style={{marginTop: "32px", marginBottom: "25px"}}>
							<InviteCard/>
						</div>
						{/* terms and privacy  */}
						<div className={styleWallet + 'terms_condition d-flex'}>
							<div className={'d-flex  align-items-center'}
							     onClick={() => props.history.push("terms-and-condition")}>
								<div className={styleWallet + "terms-dot mx-1"}/>
								<p className={styleWallet + "terms-text my-1 mr-4"}>Terms & Conditions</p>
							</div>
							<div className={'d-flex  align-items-center'}
							     onClick={() => props.history.push("privacy-policy")}>
								<div className={styleWallet + "terms-dot mx-1"}/>
								<p className={styleWallet + "terms-text my-1 mx-1"}>Privacy Policy</p>
							</div>
						</div>
					</div>
					<div className={"bottom-space"}/>

					{/* bottom nav */}
					<div className={styleWallet + "bottom-nav"}>
						<MDBModal fullHeight={false} position="bottom" overflowScroll={true} inline={false}
						          noClickableBodyWithoutBackdrop={false} isOpen={activeModal}>
							<MDBModalBody>
								{
									activeModal === "add" ?
										<AddMoney
											setActiveModal={(args) => setActiveModal(args)}
											user_details={props.user_details}
										/> :
										activeModal === "withdraw" ?
											<WithdrawMoney
												setActiveModal={(args) => setActiveModal(args)}
												user_details={props.user_details}
											/> :
											activeModal === "cash" ?
												<CashDetail setActiveModal={(args) => setActiveModal(args)}/> :
												activeModal === "walletData" ?
													<NetWorthModal setActiveModal={(args) => setActiveModal(args)}/> :
													null
								}
							</MDBModalBody>
						</MDBModal>

						<BottomNav/>
					</div>

					<MDBModal isOpen={signOutConfirmation} overflowScroll={true} noClickableBodyWithoutBackdrop={false}
					          inline={false}>
						{/*<MDBModalHeader toggle={this.toggle}>MDBModal title</MDBModalHeader>*/}
						<MDBModalBody style={{padding: "24px"}}>

							<div className="wrong_text" onClick={() => setActiveModal("")}>
								<img src={wrong_image} alt="Italian-Trulli" className="wrong_icon"
								     onClick={() => setSignOutConfirmation(false)}/>
							</div>
							<div className={'d-flex justify-content-center'} style={{marginTop: "6px"}}>
								<img src={lock} alt={"alt"} className={"main-image"}/>
							</div>

							<p className={"confirmation-text "}>Are you sure you want to log out ?</p>
							<div className={'d-flex w-100'}>
								<button onClick={() => setSignOutConfirmation(false)}
								        className={"confrimation-button-1 d-flex justify-content-center p-3 align-items-center mx-1"}>
									<p className={"confirmation-button-text mr-2 mb-0"}>Cancel</p>
									<img src={arrowPurple} alt={"alt"}/>
								</button>
								<button onClick={logout}
								        className={"confrimation-button-2 d-flex align-items-center justify-content-center p-3 mx-1  "}>
									<p className={"confirmation-button-text mr-2 mb-0"}>Log out</p>
									<img src={arrow} alt={"alt"}/>
								</button>
							</div>
						</MDBModalBody>

					</MDBModal>

				</div>
			</ScrollToTop>
		</Loading>
	)
}
const mapStateToProps = state => ({
	user_details: state.UserReducer.user_details,
	order_data: state.OrderReducer.order_data,
	wallet_data: state.WalletReducer.wallet_data
});

const mapDispatchToProps = dispatch => ({
	setActivePage: data => dispatch(setActivePage(data)),
	setWalletDataToStore: data => dispatch(AddWalletData(data))
})

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps)
)(WalletLanding);
